export default __webpack_public_path__ + "images/67903678b289ef3586a24f60bf8f96a3-pulse.png";